import { render, staticRenderFns } from "./profile-tag.vue?vue&type=template&id=50b15ff8"
import script from "./profile-tag.vue?vue&type=script&lang=js"
export * from "./profile-tag.vue?vue&type=script&lang=js"
import style0 from "./profile-tag.vue?vue&type=style&index=0&id=50b15ff8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VIcon: require('/app/node_modules/vuetify/lib/components/VIcon/VIcon.js').default})


/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandXTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VExpandXTransition,VIcon})
